import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';

import { API_URL } from '../constants/api';
import { ENDPOINTS } from '../constants/api';
import { getToken ,decodeToken} from '../utils/TokenUtils';
import DetailData from './DetailData';
import { useTranslation } from 'react-i18next';
import CustomerCareDashboard from './CustomerCareDashboard';

export default function Charts() {


  const token = getToken();
  const { t } = useTranslation();
  const [stats, setStats] = useState([]);

  const userType = decodeToken(token, 'userLevel');

  const [selectedId, setSelectedId] = useState(null);
  const [chartTitle, setChartTitle] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const allowedUserTypes = [
  "eng_development",
  "customer_care",
  "eng_customer_care",
  "admin",
  "developer",
];

const isAllowedAPI = API_URL === "https://newktcapi.kaafi.net";
const isAllowedUser = allowedUserTypes.includes(userType);

  const openModal = (id, title) => {
    setSelectedId(id);
    setChartTitle(title);

    console.log('id:', id);
    // setUpdateTable()
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setSelectedId(0);
    setIsModalOpen(false);
  };

  useEffect(() => {
    const chartsUrl = `${API_URL}/${ENDPOINTS.SYS}/get-charts`;

    const fetchCharts = async (url) => {
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setStats(response.data);
        // console.log(response.data);
      } catch (error) {
        console.log('Error fetching links ', error, 'url: ', url);
        setStats([]);
      }
    };

    fetchCharts(chartsUrl);
  }, []);

  return (
    <>
      <div className="container-fluid p-4">
        <h2>Dashboard</h2>
        {selectedId && (
          <DetailData
            token={token}
            id={selectedId}
            route="get-chart-detail"
            title={chartTitle}
            isOpen={isModalOpen}
            onRequestClose={closeModal}
          />
        )}
        <div className="row">
          {stats &&
            stats.length > 0 &&
            stats.map((stat, index) => (
              <div
                className="col-12 col-sm-6 col-md-3 mb-3"
                key={index}
                onClick={() => openModal(stat.id, stat.title)}
              >
                <div className={`card text-white bg-${stat.bg_color} h-100`}>
                  <div className="card-body d-flex flex-column">
                    <FeatherIcon icon={stat.icon} />
                    <h4 className="card-title mt-3">{t(stat.title)}</h4>
                    <p className="card-text h5">{stat.value}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
       
       {isAllowedAPI && isAllowedUser && <CustomerCareDashboard />}
      
    </>
  );
}
